export const ROOT_ROUTES = ['Login', 'Forms', 'Checks', 'End'] as const;
